module.exports = __webpack_public_path__ + "img/jquery.788c9e06.png";